// src/components/Reports.jsx
import React from "react";
import { Link } from "react-router-dom";
import PageLayout from "./Pageout";

const Reports = () => (
  <PageLayout title="Reports">
    <section className="content">
      <div className="card"><h3><Link to="/reports/dealers">Dealer Reports</Link></h3><p>Performance, sales, compliance</p></div>
      <div className="card"><h3><Link to="/reports/delivery-partners">Delivery Partner Report</Link></h3><p>On-time delivery, earnings</p></div>
      <div className="card"><h3><Link to="/reports/tasks">Task Report</Link></h3><p>Task completion, SLA trends</p></div>
    </section>
  </PageLayout>
);

export default Reports;